import Kfit from 'integrations/Kfit';

export default params =>
  Kfit.post('/v7/qr_codes/email', params).then(res => res);
